module.exports = __webpack_public_path__ + "static/media/3-open-resources.2c124503.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sketch-how-to/3-open-resources.png
// module id = 222
// module chunks = 0